import React from 'react'
import styled from 'styled-components/macro'

type Props = {
  children: JSX.Element
}

export const SearchContainer = ({ children }: Props) => {
  return (
    <SubContainer>
      <SubSearch>{children}</SubSearch>
    </SubContainer>
  )
}

export default SearchContainer

const SubContainer = styled.div`
  margin-top: 24px;
`
const SubSearch = styled.div`
  margin: 0 auto;
  max-width: 680px;
`
